import React from "react";
import { Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

const NavItems = [
  {
    title: "پیگیری ها",
    url: "/requests",

    icon: (
      <img className="icon-size" src="/images/svg/peigiri-desktop.svg" alt="" />
    ),
  },

  {
    title: "صندوق طلا و نقره",
    url: "/gold-balance",

    icon: (
      <img
        className="icon-size"
        src={"/images/svg/sandogh-desktop.svg"}
        alt=" صندوق طلا و نقره"
      />
    ),
  },

  {
    title: "افزایش دارایی",
    url: "/deposit",

    icon: (
      <img
        className="icon-size"
        src={"/images/svg/charge-wallet-desktop.svg"}
        alt="افزایش دارایی"
      />
    ),
  },

  {
    title: " کیف پول",
    url: "/kifpool",

    icon: (
      <img
        className="icon-size"
        src={"/images/svg/wallet-desktop.svg"}
        alt=""
      />
    ),
  },
];

const NavItemsMob = [
  {
    title: "پیگیری ها",
    url: "/requests",

    icon: <img className="icon-size" src="./images/svg/peygiri.svg" alt="" />,
  },
  {
    title: "صندوق طلا و نقره",
    url: "/gold-balance",
    icon: (
      <img
        className="icon-size"
        src={"images/svg/sandogh.svg"}
        alt="صندوق طلا و نقره"
      />
    ),

    activeIcon: (
      <img
        className="icon-size"
        src={"images/svg/wallet.svg"}
        alt="و نقره صندوق طلا"
      />
    ),
  },
  {
    title: "افزایش دارایی",
    url: "/deposit",

    icon: (
      <img
        className="icon-size"
        src={"images/svg/increase-income.svg"}
        alt="افزایش دارایی"
      />
    ),
  },

  {
    title: "کیف پول",
    url: "/kifpool",

    icon: <img className="icon-size" src={"images/svg/wallet.svg"} alt="" />,
  },
];

export default function ItemsMoreMenu() {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 768px)" });

  return (
    <>
      <div className="items-more-wrapper">
        <div className="items-more">
          {(isTabletOrMobile ? NavItemsMob : NavItems).map((item, index) => (
            <div className="nav-item-content" key={`menu-item-${index}`}>
              <Link to={item.url} className="fsmfsmr">
                {item.icon}
                <p className="nav-item-title34">{item.title}</p>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
